// extracted by mini-css-extract-plugin
export default {"wrapper":"_269d4b0e"};